export const ESTIMATED_VALUE_TOO_LARGE = 'ESTIMATED_VALUE_TOO_LARGE';
export const QUANTITY_MISSING = 'QUANTITY_MISSING';
export const QUANTITY_UNIT_MISSING = 'QUANTITY_UNIT_MISSING';
export const WEIGHT_MISSING = 'WEIGHT_MISSING';
